import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { Card, CardHeader, Stack, Text } from "@chakra-ui/react";

import { selectActiveProperties } from "../../../redux/user/userSlice";
import { getPropertyAddress } from "../../../utils/verifier";

import PropertyDocumentsCard from "./PropertyDocumentsCard";

export default function Documents() {
	const properties = useSelector(selectActiveProperties);
	const { t } = useTranslation();
	return (
		<Stack>
			<Card>
				<CardHeader>
					<Text fontSize="xl" fontWeight="bold">
						{t("navbarMenu.documents")}
					</Text>
				</CardHeader>
			</Card>
			{properties.map((property, index) => (
				<PropertyDocumentsCard
					documents={property.documents}
					reports={property.reports}
					address={getPropertyAddress(property)}
					propertyId={property.id}
					key={index}
				/>
			))}
		</Stack>
	);
}
